import { isEmpty } from '@/utils/general/browserHelper'
import { getFarePricingAttributes, getFaresInfo, getSearchIntentDetails, isPerAdultPricing } from '@/utils/srp/helper'

export const getIntlEmiCalloutPayloadFf = (
  searchData: any,
  sortedFilteredCards: any,
  searchQuery: Record<string, string | string[] | undefined>,
  noCostEmi: any
) => {
  const payload = {
    flight_list: [
      {
        uuid: constructEmiPriceUuidFf(sortedFilteredCards[0][0], searchData),
        amount: getFlightPriceFf(sortedFilteredCards[0][0], searchData),
      },
    ],
    sid: searchData.searchId,
    ...commonPayloadPartFf(searchQuery, noCostEmi),
  }
  return payload
}

export const getEmiDataPayloadFf = (
  totalCount: number,
  sIndex: number,
  displayList: any[],
  emiData: any,
  type: string,
  fareId: string,
  resultsData: any
) => {
  let start = 0
  const dataObj = {}
  const flightReqData = []
  const uuidList = []
  if (sIndex >= 0) {
    while (start < totalCount && sIndex + start < displayList.length) {
      const flightData = displayList[sIndex + start] || {}
      let uuid = ''
      ++start
      if (isEmpty(emiData && emiData[flightData.cardId])) {
        dataObj[flightData.cardId] = {
          isLoading: true,
        }
        uuid = constructEmiPriceUuidFf(flightData, resultsData, fareId)
        uuidList.push({ id: flightData.cardId, uuid })
        flightReqData.push({
          uuid,
          amount: getFlightPriceFf(flightData, resultsData),
        })
      }
    }
  }
  return { dataObj, flightReqData, uuidList }
}

export const getFlightPriceFf = (flightData: any, resultsData: any, isCheckInBaggageEnabled?: boolean) => {
  const { subTravelOptions = [], fares = [], searchIntent } = resultsData || {}
  const { paxCriteria = [] } = getSearchIntentDetails(searchIntent)
  const showPerAdultPricing = isPerAdultPricing(paxCriteria)
  const faresList = getFaresInfo(flightData, subTravelOptions, fares, false, isCheckInBaggageEnabled) || []
  const { displayPrice = 0 } = getFarePricingAttributes({ fare: faresList?.[0], showPerAdultPricing }) || {}
  return Math.round(displayPrice)
}

export const commonPayloadPartFf = (searchQuery: Record<string, string | string[] | undefined>, noCostEmi: any) => {
  const commonPayload = {
    from: searchQuery.from,
    to: searchQuery.to,
    international: searchQuery.intl === 'y',
    payment_context_list: [
      {
        payment_mode: 'EMI',
        payment_sub_mode: noCostEmi.enabled ? 'NOCOST' : 'REGULAR',
      },
    ],
  }
  return commonPayload
}

export const constructEmiPriceUuidFf = (
  flightData: any,
  resultsData: any = {},
  fareId = 'REGULAR',
  isCheckInBaggageEnabled?: boolean
) => {
  let uuid = ''
  flightData?.summary?.flights?.forEach((flight: any = {}, index: number) => {
    if (index > 0) {
      uuid += '|'
    }
    const { airlineCode = '', flightNumber = '' } = flight || {}
    uuid += `${airlineCode}-${flightNumber}`
    uuid = `${uuid}_${fareId}`
  })
  uuid = `${uuid}|price_${getFlightPriceFf(flightData, resultsData, isCheckInBaggageEnabled)}`
  return uuid
}
